import { constants } from '../../constants'

const styles = {
    buttonIconStyle: {
        color: 'rgba(255,255,255,0.9)',
        display: 'flex',
        fontSize: 25,
        justifyContent: 'center',
        marginRight: 10,
        textAlign: 'center',
    },
    buttonStyle: {
        alignItems: 'center',
        backgroundColor: constants.color.secondary || '#000000',
        borderRadius: 15,
        borderStyle: 'none',
        borderWidth: 0,
        display: 'flex',
        padding: '10px 20px',
        verticalAlign: 'middle',
    },
    container: {
        display: 'flex',
        justifyContent: 'center'
    },
    textStyle: {
        color: 'rgba(0,0,0,0.5)',
        fontSize: constants.text.baseFontStyles.fontSize,
        fontWeight: '500',
    },
}

export { styles as buttonStyles };


// WEBPACK FOOTER //
// ./src/js/components/Button/styles.ts